export default "__VITE_ASSET__U4a9BLb___"